// extracted by mini-css-extract-plugin
export default {"add-role-modal":"EditRole_add-role-modal__uy9AN"};